export const categories = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Sneakers, trainers, boots, and casual footwear',
    imageQuery: 'Clean%20minimalist%20sneaker%20photography%20on%20cream%20background%2C%20white%20leather%20trainers%20with%20elegant%20stitching%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20earthy%20tones%2C%20no%20text%2C%20editorial%20quality%2C%20simple%20composition%20with%20gentle%20shadows',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Comfortable hoodies, crewnecks, and knit sweaters',
    imageQuery: 'Cozy%20oversized%20hoodie%20photography%20on%20neutral%20cream%20backdrop%2C%20soft%20premium%20fabric%20texture%2C%20warm%20earthy%20beige%20tone%2C%20minimalist%20product%20shot%2C%20natural%20daylight%2C%20clean%20composition%2C%20editorial%20fashion%20photography%2C%20no%20text',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Premium cotton tees, graphic prints, and basics',
    imageQuery: 'Premium%20white%20cotton%20t-shirt%20flat%20lay%20photography%20on%20cream%20linen%20background%2C%20soft%20fabric%20drape%2C%20minimalist%20style%2C%20warm%20natural%20light%2C%20clean%20product%20photography%2C%20elegant%20simplicity%2C%20no%20text%2C%20editorial%20quality',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Bombers, denim jackets, windbreakers, and coats',
    imageQuery: 'Stylish%20bomber%20jacket%20photography%20on%20light%20cream%20backdrop%2C%20olive%20green%20fabric%20with%20subtle%20sheen%2C%20minimal%20styling%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20earthy%20vibe%2C%20no%20text%2C%20clean%20composition',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Cargo pants, jeans, joggers, and seasonal shorts',
    imageQuery: 'Tailored%20beige%20chino%20pants%20photography%20on%20neutral%20cream%20surface%2C%20clean%20folded%20presentation%2C%20soft%20cotton%20texture%2C%20minimalist%20product%20styling%2C%20warm%20daylight%2C%20editorial%20quality%2C%20no%20text%2C%20simple%20elegance',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies, bucket hats, and snapbacks',
    imageQuery: 'Classic%20baseball%20cap%20photography%20on%20cream%20background%2C%20soft%20textured%20fabric%2C%20minimalist%20styling%2C%20warm%20natural%20lighting%2C%20clean%20product%20shot%2C%20earthy%20color%20palette%2C%20no%20text%2C%20editorial%20fashion%20photography',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Matching tracksuits, co-ord sets, and outfit bundles',
    imageQuery: 'Matching%20tracksuit%20set%20photography%20on%20warm%20cream%20backdrop%2C%20coordinated%20athleisure%20outfit%2C%20soft%20fabric%20texture%2C%20minimalist%20composition%2C%20natural%20daylight%2C%20clean%20editorial%20style%2C%20no%20text%2C%20earthy%20tones',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Boxers, briefs, trunks, and comfort essentials',
    imageQuery: 'Premium%20cotton%20underwear%20flat%20lay%20photography%20on%20cream%20background%2C%20soft%20folded%20fabric%2C%20minimalist%20aesthetic%2C%20warm%20gentle%20lighting%2C%20clean%20product%20presentation%2C%20neutral%20earthy%20tone%2C%20no%20text',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys, football kits, and athletic wear',
    imageQuery: 'Professional%20sports%20jersey%20photography%20on%20light%20cream%20backdrop%2C%20athletic%20fabric%20with%20subtle%20pattern%2C%20clean%20minimal%20styling%2C%20soft%20studio%20lighting%2C%20product%20photography%20style%2C%20warm%20tones%2C%20no%20text',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches, sunglasses, jewelry, and fashion accents',
    imageQuery: 'Elegant%20minimalist%20watch%20photography%20on%20cream%20marble%20surface%2C%20rose%20gold%20details%2C%20soft%20natural%20lighting%2C%20clean%20luxury%20product%20shot%2C%20warm%20earthy%20aesthetic%2C%20editorial%20quality%2C%20no%20text%2C%20refined%20simplicity',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, crossbody bags, totes, and travel gear',
    imageQuery: 'Stylish%20leather%20backpack%20photography%20on%20cream%20background%2C%20rich%20brown%20cognac%20leather%20texture%2C%20minimalist%20product%20styling%2C%20soft%20natural%20daylight%2C%20clean%20editorial%20composition%2C%20earthy%20warm%20tones%2C%20no%20text',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Leather belts, canvas belts, and designer buckles',
    imageQuery: 'Premium%20leather%20belt%20rolled%20photography%20on%20cream%20surface%2C%20rich%20brown%20texture%20with%20brass%20buckle%2C%20minimalist%20product%20shot%2C%20soft%20lighting%2C%20warm%20earthy%20aesthetic%2C%20clean%20elegant%20style%2C%20no%20text',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Designer fragrances, colognes, and scent collections',
    imageQuery: 'Elegant%20glass%20perfume%20bottle%20photography%20on%20cream%20background%2C%20amber%20liquid%20with%20golden%20accents%2C%20soft%20diffused%20lighting%2C%20minimalist%20luxury%20product%20shot%2C%20warm%20earthy%20vibe%2C%20editorial%20quality%2C%20no%20text',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Electronics, home goods, gadgets, and miscellaneous finds',
    imageQuery: 'Curated%20lifestyle%20product%20flat%20lay%20photography%20on%20cream%20background%2C%20assorted%20minimalist%20accessories%2C%20warm%20natural%20lighting%2C%20clean%20organized%20composition%2C%20editorial%20style%2C%20earthy%20neutral%20tones%2C%20no%20text',
  },
];

export const featureBenefits = [
  {
    icon: 'ri-database-2-line',
    title: 'Structured Product Comparison',
    description: 'Compare products side by side with organized spreadsheet data for smarter decisions.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Updated Spreadsheet Insights',
    description: 'Regularly refreshed product data keeps you informed about the latest deals and alternatives.',
  },
  {
    icon: 'ri-filter-3-line',
    title: 'Fast Filtering & Smart Categories',
    description: 'Navigate through 15+ curated categories to find exactly what you are looking for instantly.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Data-Driven Buying Decisions',
    description: 'Make informed purchases backed by structured data rather than impulse browsing.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Alternative Product Finder',
    description: 'Discover quality alternatives and hidden gems across multiple product categories.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Deal Comparison System',
    description: 'Spot the best value across products with our systematic comparison methodology.',
  },
];